import { Component } from '@angular/core';

@Component({
  selector: 'app-regulator-icon',
  templateUrl: './regulator-icon.component.svg',
  styleUrls: ['./regulator-icon.component.scss']
})
export class RegulatorIconComponent
{

  constructor() { }

}
